import React, { useEffect, useState } from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { Badge } from './ui/badge';
import { Sparkles } from 'lucide-react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { useLang } from '../context/LangContext';

export const StoryPrompt = ({ apps }) => {
  const { t } = useLang();
  const [data, setData] = useState(null);
  const [text, setText] = useState('');
  const [program, setProgram] = useState('');
  const load = () => api.get('/stories/eligible').then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, [apps]); // eslint-disable-line
  if (!data || !data.eligible.length) return null;
  const open = data.eligible.filter((a) => !data.mine.some((m) => m.program === a.program_id && m.status !== 'rejected'));
  const submit = async () => {
    if (text.trim().length < 20) return toast.error(t('Write at least 20 characters'));
    try { await api.post('/stories', { program: program || open[0].program_id, text }); toast.success(t('Thank you! Your note will appear once reviewed.')); setText(''); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Could not submit'); }
  };
  return (
    <Card className="p-5 mb-6 bg-[#FFF7F0] border-[#C26227]/30" data-testid="story-prompt">
      <div className="font-semibold flex items-center gap-2 text-[#C26227]" style={{fontFamily: 'Lexend'}}><Sparkles className="w-4 h-4" /> {t('You got approved — help someone keep going')}</div>
      {open.length > 0 ? (
        <>
          <p className="text-sm text-foreground/80 mt-1">{t('Share a short anonymous note (max 200 characters) about what worked. No names or personal details are shown.')}</p>
          {open.length > 1 && <div className="flex gap-2 mt-2 flex-wrap">{open.map((a) => <Button key={a.program_id} size="sm" variant={(program || open[0].program_id) === a.program_id ? 'default' : 'outline'} onClick={() => setProgram(a.program_id)} data-testid={`story-program-${a.program_id}`}>{a.program_name}</Button>)}</div>}
          <Textarea value={text} onChange={(e) => setText(e.target.value.slice(0, 200))} rows={2} className="mt-2 bg-card" placeholder={t('e.g. My doctor rewrote the form describing my bad days. Approved 3 months later.')} data-testid="story-text" />
          <div className="flex items-center justify-between mt-2"><span className="text-xs text-muted-foreground">{200 - text.length}</span><Button size="sm" onClick={submit} className="bg-[#C26227] hover:bg-[#C26227]/90 text-white" data-testid="story-submit">{t('Share anonymously')}</Button></div>
        </>
      ) : null}
      {data.mine.length > 0 && <ul className="mt-3 space-y-1.5 text-sm" data-testid="story-mine">{data.mine.map((m) => <li key={m.story_id} className="flex items-start gap-2"><Badge className={`border-0 shrink-0 ${m.status === 'approved' ? 'bg-[#E6F4EA] text-[#0F5132]' : m.status === 'pending' ? 'bg-[#FEF3C7] text-[#92400E]' : 'bg-secondary'}`}>{t(m.status === 'approved' ? 'Published' : m.status === 'pending' ? 'In review' : 'Not published')}</Badge><span className="text-foreground/80">“{m.text}”</span></li>)}</ul>}
    </Card>
  );
};
